require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-middle-park-domain-magazine.json") })
        }
      }, "path---journal-middle-park-domain-magazine");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-middle-park-domain-magazine!./.cache/json/journal-middle-park-domain-magazine.json
// module id = 514
// module chunks = 231608221292675